/** @format */
import angular from 'angular';
import 'js-data';

export const commonModuleModelModule = 'sis-components.model.commonModule';

(function () {
    commonModuleModel.$inject = ['DS'];
    angular
        .module(commonModuleModelModule, ['js-data'])
        .factory('commonModuleModel', commonModuleModel)
        .run(['commonModuleModel', commonModuleModel => {}]); // NOSONAR

    function commonModuleModel(DS) {
        return DS.defineResource({
            idAttribute: 'id',
            name: 'commonModule',
            endpoint: '/kori/api/modules',
        });
    }
})();
